export const getSortingEditKey = state => {
  return state.sortingEditKey
}

export const getProductRegExp = state => {
  return /(^[.,?*+\-_^$฿#@!%^&'"<>=~/[\]\\(){}|])|(['"/\\])/g
}

export const getProductUnderCategoryCount = state => {
  return state.result.productUnderCategoryCount
}

export const getProductTabSelected = state => {
  return state.productTabSelected
}

export const getCurrentView = state => {
  return state.currentView
}



// WEBPACK FOOTER //
// ./src/store/modules/products/getters.js